import { ImageEndpoints } from "burde";
import { CalendarSizes } from "./constants";

export const getImageUrlByCalendarSize = (
    endpoints: ImageEndpoints,
    calendarSize: string,
) => {
    switch (calendarSize.toLowerCase()) {
        case CalendarSizes.A5:
            return endpoints.a5;
        case CalendarSizes.A6:
            return endpoints.a6;
        case CalendarSizes.B5:
            return endpoints.b5;
        case CalendarSizes.Preview:
            return endpoints.preview;
        default:
            return endpoints.a5;
    }
};
